import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import ModalComponent from "../components/ModalCompnent/modal.component";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IPosPoint } from "../components/MapComponent/Map.component";
import { Instalation } from "../utils/models/Instalation";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { deleteInstalation, getAllInstalations, createInstalation, getInstalationsPage } from "../utils/services/instalation.service";
import InstalationForm from "../components/InstalationComponents/InstalationForm/InstalationForm.component";
import InstalationGrid from "../components/InstalationComponents/InstalationGrid/InstalationGrid.component";
import { IToastProps, NotificationToast } from "aw-notificationtoast";
import { ButtonsLine } from "aw-management-buttons-line";
import { ROLES } from "aw-consts";
import { ColumnFiltersState, SortingState } from "@tanstack/react-table";

const InstalationPage = () => {
    const [isNew, setIsNew] = useState(false)
    const [loding, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false })
    const [newEditDelObj, setNewEditDelObj] = useState(new Instalation())
    const [containers, setContainers] = useState<Instalation[]>([])
    const [formLock, setFormLock] = useState(false)
    const [active, setActive] = useState(true)
    const [sorting, setSorting] = useState<SortingState>([])
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 })
    const [total, setTotal] = useState(0)
    const [filters, setFilters] = useState<ColumnFiltersState>([])
    const [manual, setManual] = useState(true) 
    
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();

    const { t } = useTranslation();

    useEffect(() => {
        context.setState(t('Installations'))
    })

    useEffect(() => {
        getAllContainersAux();
    }, [])

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast })
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000)
    }

    const newClick = () => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noCreatePermissions'), true)
        } else {
            setFormLock(false)
            setIsNew(true)
            setActive(true)
            setActive(true)
        }
    }

    const getAllContainersAux = () => {
        setLoading(true)
        getAllInstalations(user.token).then((json) => {
            setContainers(json)
        }).catch((e) => {
            showToastTimeOut(t('ErrorLoad'), true)
        }).finally(() => { setTimeout(() => { setLoading(false) }, 500) })
    }
    const getContainersPageAux = () => {
        const PAGE_SIZE = 2
        getInstalationsPage(
            user.token,
            pagination.pageIndex + 1,
            pagination.pageSize || PAGE_SIZE,
            filters,
            sorting[0]?.id,
            sorting[0]?.desc ? "DESC" : "ASC"
        )
            .then((json) => {
                setContainers(json.data)
                setTotal(json.totalPages)
            })
            .catch(() => showToastTimeOut(t("ErrorLoad"), true))
            .finally(() => setTimeout(() => setLoading(false), 500))
    }

    useEffect(() => {
        if (manual) getContainersPageAux()
    }, [pagination, filters, sorting])

    const saveClick = () => {
        if(user.role === ROLES.Demo){
            showToastTimeOut(t('noEditPermissions'), true)
            return
        }
        newEditDelObj.active = active
        if (newEditDelObj.name.length !== 0) {
            createInstalation(user.token, newEditDelObj).then((json) => {
                let c = []
                let msg = t('CreatedContainerOK')

                if (newEditDelObj.idinstalation > 0) {
                    msg = t('UpdatedContainerOK')
                    const newContainer = containers.filter((i) => i.idinstalation !== json.idinstalation);
                    c = [...newContainer, json]
                } else { c = [...containers, json] }

                setContainers(c)
                setIsNew(false)
                setNewEditDelObj(new Instalation())
                showToastTimeOut(msg, false)
            }
            ).catch(() => {
                setIsNew(false)
                setNewEditDelObj(new Instalation())
                showToastTimeOut(t('ContainerError'), true)
            }
            )
        } else {
            showToastTimeOut(t('RequireParams'), true)
        }
    }

    const cancelClick = () => {
        setIsNew(false)
        setNewEditDelObj(new Instalation())
    }

    const editClick = (c: Instalation) => {
        setFormLock(true)
        setIsNew(true)
        setNewEditDelObj(c)
        setActive(c.active)
    }

    const deleteClick = (c: Instalation) => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noDeletePermissions'), true)
        }
        else {
            setShowModal(true)
            setNewEditDelObj(c)
        }
    }

    const DesBloquearClick = () => {
        setFormLock(!formLock)
    }

    const onFormChange = (event: any) => {
        const { name, value } = event.target;
        if (name === 'active') {
            setActive(!active)

        } else {
            setNewEditDelObj((data: any) => ({
                ...data,
                [name]: value
            }));
        }
    }

    const ModalNo = () => {
        setShowModal(false)
    }

    const ModalYes = () => {
        setShowModal(false)

        deleteInstalation(user.token, newEditDelObj.idinstalation).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                const newContainers = containers.filter((containers) => containers !== newEditDelObj);
                setContainers(newContainers);
                setNewEditDelObj(new Instalation())
                showToastTimeOut(t('DeleteContainerOK'), false)
            } else { throw new Error() }
        }).catch(() => {
            setNewEditDelObj(new Instalation())
            showToastTimeOut(t('DeleteContainerError'), true)
        })
    }

    const onChangePos = (pos: IPosPoint) => {
        setNewEditDelObj((data: any) => ({
            ...data,
            lat: pos.lat,
            lng: pos.lng
        }));
    }

    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <ModalComponent showModal={showModal} textDel={`${t('QuestionDelete')} ${newEditDelObj.name}?`} onClickNo={ModalNo} onClickYes={ModalYes} />
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <ButtonsLine comboOptions={[]} onChangeSelected={() => { return null }} selectedOption={null} edit={isNew} viewMode={false} formLock={formLock} onClickNew={newClick} onClickSave={saveClick}
                        onClickCancel={cancelClick} onClickDesBloquear={DesBloquearClick} comboOptions2={[]} onChangeSelected2={() => { return null }} selectedOption2={null}
                        comboName="" comboName2="" classNameDanger="btn-Custom btn-IDRed" classNamePrimary="btn-Custom btn-Grey" classNameSuccess="btn-Custom btn-IDGreen" classNameNeutral="btn-Simple"
                        containerColor="var(--background-secondary)" rounded="rounded-1" dark={true} saveText={t('Save')}/>
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    {isNew ? <InstalationForm edit={isNew} containerAux={newEditDelObj} sendChange={onFormChange}
                        formLock={formLock} onChangePos={onChangePos} />
                        : 
                        <InstalationGrid
                            instalations={containers}
                            onEditClick={editClick}
                            onDeleteClick={deleteClick}
                            edit={true}
                            loading={loding}
                            onContainerClick={() => null}
                            pagination={pagination}
                            total={total}
                            setPagination={setPagination}
                            filters={filters}
                            setFilters={setFilters}
                            sorting={sorting}
                            setSorting={setSorting}
                            manual={manual}
                        />
                        }
                </div>
            </div >
        </>
    )
}

export default InstalationPage